module.exports = __webpack_public_path__ + "img/priest.fbc4d9ef.jpg";